import React, { useEffect } from 'react';
import * as Styles from './DeleteKeyModal.styles';
import {
  Modal, Button,
} from 'gatorcomponents';

import useLocale from '@/hooks/useLocale';

import { useParams } from 'react-router-dom';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { vpsOciActions } from '@/redux/modules/productDetail/vpsOci';

const DeleteKeyModal = ({
  onClose,
  selectedSshKey,
}) => {
  const dispatch = useDispatch();
  const { id: hostingId } = useParams();

  const { loading, error, success } = useSelector(state => ({
    loading: state.vpsOci?.sshKeys?.delete?.loading,
    error: state.vpsOci?.sshKeys?.delete?.error,
    success: state.vpsOci?.sshKeys?.delete?.success,
  }), shallowEqual);

  const { productDetails: productDetailsLocale } = useLocale();
  const { sshKeys: sshKeysLocale } = productDetailsLocale?.vpsOci;

  const handleCloseModal = () => {
    onClose && onClose();
  };

  const handleDeleteSshKey = () => {
    const sshKeyData = {
      name: selectedSshKey?.name,
      id: selectedSshKey?.id,
    };
    dispatch(vpsOciActions.sshKeys.delete.request(hostingId, sshKeyData));
  };

  useEffect(() => {
    if (success) {
      dispatch(vpsOciActions.sshKeys.delete.reset());
      onClose && onClose();
    }
  }, [success, dispatch, onClose]);

  return (
    <Modal
      onClose={handleCloseModal}
      maxWidth={500}
      noContentPadding
      title={sshKeysLocale.management.modal.deleteKey.title}
      testId="ssh-keys-delete-key-modal"
    >
      <Styles.ModalContent>
        <Styles.ModalHeader>
          <Styles.ModalSubtitle data-testid="ssh-keys-delete-key-modal-subtitle">
            {sshKeysLocale.management.modal.deleteKey.description(selectedSshKey?.name)}
          </Styles.ModalSubtitle>
        </Styles.ModalHeader>
        <Styles.ModalButtonsWrapper>
          <Button
            label={sshKeysLocale.management.modal.deleteKey.buttons.cancel}
            variant="tertiary"
            size="large"
            version="v2"
            width="full"
            onClick={onClose}
            testId="ssh-keys-delete-key-modal-cancel-button"
          />
          <Button
            label={sshKeysLocale.management.modal.deleteKey.buttons.delete}
            variant="secondary"
            negative
            size="large"
            version="v2"
            width="full"
            onClick={loading ? null : handleDeleteSshKey}
            loading={loading}
            disabled={error}
            testId="ssh-keys-delete-key-modal-delete-button"
          />
        </Styles.ModalButtonsWrapper>
      </Styles.ModalContent>
    </Modal>
  );
};

export default DeleteKeyModal;
